const FileViewer: React.FC<{ src: string; height: string; width: string }> = props => {
  return <iframe src={props.src} height={props.height} width={props.width} title={props.src} id="viewer-Iframe" name={`${Date.now()}`} allowFullScreen={true} />;
};

export default FileViewer;
